module.exports = __webpack_public_path__ + "static/media/deal-prize-draw.e6ebd363.png";